import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { AuthPanel } from '@/components/auth/AuthPanel';
import { useLoginForm } from '../../hooks/useLoginForm';
import './LoginForm.scss';

export const LoginForm = () => {
  const { email, setEmail, password, setPassword, isLoading, error, onSubmit } = useLoginForm();

  return (
    <form onSubmit={onSubmit} noValidate>
      <AuthPanel
        kicker="AUTHENTICATION"
        heading="Sign in"
        subtitle="Welcome back to ProWatchly."
        footer={
          <>
            Don't have an account? <Link to="/signup">Create one</Link>
          </>
        }
      >
        <div className="login-form__fields">
          <Input
            label="Work email"
            type="email"
            name="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="you@company.com"
          />

          <Input
            label="Password"
            type="password"
            name="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="••••••••"
          />
          {/* Right-aligned recovery link right under the password field —
              puts the path out the moment a user is stuck typing the wrong
              password. */}
          <Link to="/forgot-password" className="login-form__forgot">
            Forgot password?
          </Link>
        </div>

        {error && (
          <div className="login-form__error" role="alert">
            {error}
          </div>
        )}

        <Button type="submit" variant="primary" size="lg" loading={isLoading}>
          Sign in
        </Button>

        <div className="login-form__trust" aria-hidden="true">
          <ShieldCheck size={12} />
          <span>TLS · Tenant-isolated · On-prem agent</span>
        </div>
      </AuthPanel>
    </form>
  );
};
